<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />

    <div class="d-flex flex-column flex-md-row justify-content-between mb-3">
      <div>
        <h2 class="mb-1">Relatório administrativo de aluguéis</h2>
        <p class="text-muted mb-0">
          Filtre aluguéis por shopping, datas, status, cliente e período.
        </p>
      </div>
      <div class="admin-report-actions align-self-md-end mt-3 mt-md-0">
        <b-form-checkbox
          v-model="rankingEnabled"
          switch
          class="mb-0"
          @change="handleRankingToggle"
        >
          Ranking
        </b-form-checkbox>

        <b-button variant="outline-secondary" @click="clearFilters">
          <span class="fas fa-times mr-2" />Limpar filtros
        </b-button>
      </div>
    </div>

    <b-form class="admin-report-filters mb-3" @submit.prevent="loadReport(1)">
      <b-row>
        <b-col cols="12" md="4" lg="3">
          <b-form-group label="Shopping" label-for="store-filter">
            <vue-select
              id="store-filter"
              v-model="storeFilterSelection"
              :options="storeFilterOptions"
              label="name"
              placeholder="Todos os shoppings"
              multiple
              :close-on-select="false"
              class="admin-store-select"
            >
              <template #list-header>
                <li class="admin-store-select-actions">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @mousedown.prevent.stop
                    @click.prevent.stop="selectAllStores"
                  >
                    Todos
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @mousedown.prevent.stop
                    @click.prevent.stop="clearStoreSelection"
                  >
                    Limpar
                  </b-button>
                </li>
              </template>
              <template #no-options> Nenhum shopping encontrado </template>
            </vue-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4" lg="3">
          <b-form-group label="Status" label-for="status">
            <vue-select
              id="status"
              v-model="statusFilterSelection"
              :options="statusFilterOptions"
              label="text"
              placeholder="Todos os status"
              multiple
              :close-on-select="false"
              class="admin-filter-select"
            >
              <template #list-header>
                <li class="admin-filter-select-actions">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @mousedown.prevent.stop
                    @click.prevent.stop="selectAllStatuses"
                  >
                    Todos
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @mousedown.prevent.stop
                    @click.prevent.stop="clearStatusSelection"
                  >
                    Limpar
                  </b-button>
                </li>
              </template>
              <template #no-options> Nenhum status encontrado </template>
            </vue-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4" lg="3">
          <b-form-group label="Carrinho" label-for="toy-id">
            <vue-select
              id="toy-id"
              v-model="toyFilterSelection"
              :options="toyFilterOptions"
              label="text"
              :placeholder="toyFilterPlaceholder"
              multiple
              :close-on-select="false"
              :disabled="storeDependentFiltersDisabled"
              class="admin-filter-select"
            >
              <template #list-header>
                <li class="admin-filter-select-actions">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    :disabled="storeDependentFiltersDisabled"
                    @mousedown.prevent.stop
                    @click.prevent.stop="selectAllToys"
                  >
                    Todos
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="storeDependentFiltersDisabled"
                    @mousedown.prevent.stop
                    @click.prevent.stop="clearToySelection"
                  >
                    Limpar
                  </b-button>
                </li>
              </template>
              <template #no-options> Nenhum carrinho encontrado </template>
            </vue-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4" lg="3">
          <b-form-group label="Cliente" label-for="customer">
            <b-form-input
              id="customer"
              v-model.trim="filters.customer"
              placeholder="Nome, CPF ou telefone"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4" lg="3">
          <b-form-group label="Período" label-for="period-id">
            <vue-select
              id="period-id"
              v-model="periodFilterSelection"
              :options="periodFilterOptions"
              label="text"
              :placeholder="periodFilterPlaceholder"
              multiple
              :close-on-select="false"
              :disabled="storeDependentFiltersDisabled"
              class="admin-filter-select"
            >
              <template #list-header>
                <li class="admin-filter-select-actions">
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    :disabled="storeDependentFiltersDisabled"
                    @mousedown.prevent.stop
                    @click.prevent.stop="selectAllPeriods"
                  >
                    Todos
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="storeDependentFiltersDisabled"
                    @mousedown.prevent.stop
                    @click.prevent.stop="clearPeriodSelection"
                  >
                    Limpar
                  </b-button>
                </li>
              </template>
              <template #no-options> Nenhum perÃ­odo encontrado </template>
            </vue-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" lg="3">
          <b-form-group label="Criado de" label-for="created-from">
            <b-form-datepicker
              id="created-from"
              v-model="filters.createdFrom"
              locale="pt-BR"
              placeholder="Data inicial"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" lg="3">
          <b-form-group label="Criado até" label-for="created-to">
            <b-form-datepicker
              id="created-to"
              v-model="filters.createdTo"
              locale="pt-BR"
              placeholder="Data final"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" lg="3">
          <b-form-group label="Finalizado de" label-for="ended-from">
            <b-form-datepicker
              id="ended-from"
              v-model="filters.endedFrom"
              locale="pt-BR"
              placeholder="Data inicial"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" lg="3">
          <b-form-group label="Finalizado até" label-for="ended-to">
            <b-form-datepicker
              id="ended-to"
              v-model="filters.endedTo"
              locale="pt-BR"
              placeholder="Data final"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-end">
          <b-button type="submit" variant="primary" :disabled="loading">
            <span class="fas fa-filter mr-2" />Filtrar
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-row class="mb-3">
      <b-col
        v-for="item in summaryItems"
        :key="item.label"
        cols="6"
        md="4"
        lg="2"
        class="mb-2"
      >
        <div class="summary-tile">
          <small class="text-muted d-block">{{ item.label }}</small>
          <strong>{{ item.value }}</strong>
        </div>
      </b-col>
    </b-row>

    <b-card
      v-if="rankingEnabled && !error"
      no-body
      class="customer-ranking mb-3"
    >
      <b-card-header
        class="d-flex flex-column flex-md-row justify-content-between align-items-md-center"
      >
        <div class="mb-2 mb-md-0">
          <strong>Ranking de clientes</strong>
          <small class="text-muted d-block">
            Top 10 considerando os filtros atuais do relatorio.
          </small>
        </div>

        <b-form-select
          v-model="rankingMetric"
          :options="rankingMetricOptions"
          class="ranking-metric-select"
        />
      </b-card-header>

      <b-table
        :items="customerRankingRows"
        :fields="customerRankingFields"
        :busy="loading"
        empty-text="Nenhum cliente encontrado para o ranking."
        responsive
        show-empty
        small
      >
        <template #cell(position)="{ index }">
          <strong>{{ index + 1 }}</strong>
        </template>

        <template #cell(customer)="{ item }">
          <strong>{{ item.customerName || '-' }}</strong>
          <small v-if="item.customerDocument" class="text-muted d-block">
            {{ item.customerDocument }}
          </small>
          <small v-if="item.customerPhone" class="text-muted d-block">
            {{ item.customerPhone }}
          </small>
        </template>

        <template #cell(metricValue)="{ item }">
          <strong>{{ formatRankingValue(item, rankingMetric) }}</strong>
        </template>

        <template #cell(loyaltyDiscountAmount)="{ item }">
          {{ item.loyaltyDiscountAmount | formatCurrency }}
        </template>

        <template #cell(totalPaid)="{ item }">
          {{ item.totalPaid | formatCurrency }}
        </template>
      </b-table>
    </b-card>

    <b-alert v-if="error" show variant="danger">
      {{ error }}
    </b-alert>

    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-2"
    >
      <small class="text-muted mb-2 mb-md-0">
        {{ visibleFields.length }} de {{ allFields.length }} colunas visíveis
      </small>

      <div class="d-flex column-toolbar">
        <b-dropdown right variant="outline-primary" text="Colunas">
          <b-dropdown-form class="column-menu">
            <div
              v-for="group in columnGroups"
              :key="group.label"
              class="column-group"
            >
              <small class="column-group-title">{{ group.label }}</small>
              <b-form-checkbox-group
                v-model="visibleColumnKeys"
                :options="group.options"
                stacked
              />
            </div>

            <div class="d-flex justify-content-between mt-2">
              <b-button
                size="sm"
                variant="link"
                class="px-0"
                @click="resetColumns"
              >
                Padrão
              </b-button>
              <b-button
                size="sm"
                variant="link"
                class="px-0"
                @click="selectAllColumns"
              >
                Todas
              </b-button>
            </div>
          </b-dropdown-form>
        </b-dropdown>

        <b-dropdown right variant="outline-secondary" text="Ordem">
          <b-dropdown-form class="column-order-menu">
            <div class="column-order-list">
              <div
                v-for="(field, index) in orderedVisibleFields"
                :key="field.key"
                class="column-order-item"
              >
                <span class="column-order-label">{{ field.label }}</span>
                <div class="column-order-actions">
                  <b-button
                    v-b-tooltip.hover
                    size="sm"
                    variant="outline-secondary"
                    title="Mover para a esquerda"
                    :disabled="index === 0"
                    @click="moveColumn(field.key, -1)"
                  >
                    <span class="fas fa-arrow-up" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    size="sm"
                    variant="outline-secondary"
                    title="Mover para a direita"
                    :disabled="index === orderedVisibleFields.length - 1"
                    @click="moveColumn(field.key, 1)"
                  >
                    <span class="fas fa-arrow-down" />
                  </b-button>
                </div>
              </div>
            </div>
          </b-dropdown-form>
        </b-dropdown>
      </div>
    </div>

    <b-alert
      v-if="!error && !loading && rows.length === 0"
      show
      variant="secondary"
      class="text-center"
    >
      Nenhum aluguel encontrado para os filtros informados.
    </b-alert>

    <div v-if="!error && (loading || rows.length > 0)" class="table-frame">
      <b-table
        :items="rows"
        :fields="visibleFields"
        :busy="loading"
        bordered
        hover
        responsive
        small
        striped
        head-variant="light"
      >
        <template #cell(id)="{ item }"> #{{ item.id }} </template>

        <template #cell(store)="{ item }">
          {{ item.store && item.store.name ? item.store.name : '-' }}
        </template>

        <template #cell(customer)="{ item }">
          <strong>{{
            item.customer && item.customer.name ? item.customer.name : '-'
          }}</strong>
          <small
            v-if="item.customer && item.customer.document"
            class="text-muted d-block"
          >
            {{ item.customer.document }}
          </small>
        </template>

        <template #cell(customerDetails)="{ item }">
          <span class="customer-info-line">
            <span
              v-if="item.customer && item.customer.document"
              class="fas fa-id-card customer-info-icon"
            />
            <span>{{ customerDocument(item) }}</span>
          </span>
          <small class="text-muted customer-info-line">
            <span
              v-if="item.customer && item.customer.phone"
              class="fas fa-phone customer-info-icon"
            />
            <span>{{ customerPhone(item) }}</span>
          </small>
          <small class="text-muted customer-info-line">
            <span
              v-if="item.customer && item.customer.email"
              class="fas fa-envelope customer-info-icon"
            />
            <span>{{ customerEmail(item) }}</span>
          </small>
        </template>

        <template #cell(signature)="{ item }">
          <div class="d-flex align-items-center">
            <b-badge
              :variant="item.hasSignature ? 'success' : 'secondary'"
              class="mr-2"
            >
              {{ item.hasSignature ? 'Assinado' : 'Sem assinatura' }}
            </b-badge>
            <b-button
              v-if="item.hasSignature"
              v-b-tooltip.hover
              size="sm"
              variant="outline-primary"
              title="Ver assinatura"
              @click="openSignatureModal(item)"
            >
              <span class="fas fa-eye" />
            </b-button>
          </div>
        </template>

        <template #cell(rescueDocument)="{ item }">
          <b-button
            v-if="item.rescueDocumentPhotoUrl"
            v-b-tooltip.hover
            size="sm"
            variant="outline-primary"
            title="Ver documento do resgate"
            @click="openRescueDocumentModal(item)"
          >
            <span class="fas fa-eye" />
          </b-button>
          <span v-else class="text-muted">-</span>
        </template>

        <template #cell(toy)="{ item }">
          {{ item.toy && item.toy.name ? item.toy.name : '-' }}
        </template>

        <template #cell(period)="{ item }">
          <span v-if="item.period">{{ item.period.time }} min</span>
          <span v-else>-</span>
        </template>

        <template #cell(createdAt)="{ item }">
          {{ item.createdAt | formatDateTime }}
        </template>

        <template #cell(endedAt)="{ item }">
          <span v-if="item.endedAt">{{ item.endedAt | formatDateTime }}</span>
          <span v-else>-</span>
        </template>

        <template #cell(extraTime)="{ item }">
          {{ getExtraTime(item) }} min
        </template>

        <template #cell(pausedTime)="{ item }">
          {{ getPausedTime(item) }} min
        </template>

        <template #cell(exceededTime)="{ item }">
          {{ getExceededTime(item) }} min
        </template>

        <template #cell(rentTime)="{ item }">
          {{ getRentTime(item) }} min
        </template>

        <template #cell(chargedTime)="{ item }">
          {{ getChargedTime(item) }} min
        </template>

        <template #cell(extraTimeReason)="{ item }">
          {{ getExtraTimeReason(item) }}
        </template>

        <template #cell(cancelReason)="{ item }">
          {{ getCancelReason(item) }}
        </template>

        <template #cell(status)="{ item }">
          <b-badge :variant="statusVariant(item.status)">
            {{ statusText(item.status) }}
          </b-badge>
        </template>

        <template #cell(cash)="{ item }">
          {{ paymentByType(item, 'cash') | formatCurrency }}
        </template>

        <template #cell(creditCard)="{ item }">
          {{ paymentByType(item, 'creditCard') | formatCurrency }}
        </template>

        <template #cell(debitCard)="{ item }">
          {{ paymentByType(item, 'debitCard') | formatCurrency }}
        </template>

        <template #cell(pix)="{ item }">
          {{ paymentByType(item, 'pix') | formatCurrency }}
        </template>

        <template #cell(discount)="{ item }">
          <span v-if="discountAmount(item)">
            -{{ discountAmount(item) | formatCurrency }}
            <small v-if="item.loyaltyDiscount" class="text-muted d-block">
              Fidelidade: {{ item.loyaltyDiscount.pointsConsumed }} pts
            </small>
          </span>
          <span v-else>-</span>
        </template>

        <template #cell(grossTotal)="{ item }">
          {{ grossPaymentTotal(item) | formatCurrency }}
        </template>

        <template #cell(total)="{ item }">
          {{ rentPaymentTotal(item) | formatCurrency }}
        </template>
      </b-table>
    </div>

    <div class="pagination-container mt-3">
      <b-button
        variant="primary"
        :disabled="loading || report.page <= 1"
        @click="loadReport(report.page - 1)"
      >
        Anterior
      </b-button>
      <span class="page-info">
        Página {{ report.page }} de {{ report.totalPages || 1 }}
      </span>
      <b-button
        variant="primary"
        :disabled="loading || report.page >= report.totalPages"
        @click="loadReport(report.page + 1)"
      >
        Próxima
      </b-button>
    </div>

    <b-modal
      v-model="signatureModal.visible"
      title="Assinatura do aluguel"
      size="lg"
      hide-footer
    >
      <div v-if="signatureModal.loading" class="text-center py-3">
        Carregando assinatura...
      </div>

      <b-alert v-else-if="signatureModal.error" show variant="danger">
        {{ signatureModal.error }}
      </b-alert>

      <div v-else>
        <b-row class="mb-3">
          <b-col cols="12" md="6" class="mb-2">
            <small class="text-muted d-block">Cliente</small>
            <strong>{{ signatureModal.context.customerName || '-' }}</strong>
            <small class="text-muted d-block">
              {{ signatureModal.context.customerDocument || '-' }}
            </small>
          </b-col>
          <b-col cols="12" md="6" class="mb-2">
            <small class="text-muted d-block">Shopping</small>
            <strong>{{ signatureModal.context.storeName || '-' }}</strong>
          </b-col>
          <b-col cols="12" md="4" class="mb-2">
            <small class="text-muted d-block">Brinquedo</small>
            {{ signatureModal.context.toyName || '-' }}
          </b-col>
          <b-col cols="12" md="4" class="mb-2">
            <small class="text-muted d-block">Período</small>
            {{ signatureModal.context.periodLabel || '-' }}
          </b-col>
          <b-col cols="12" md="4" class="mb-2">
            <small class="text-muted d-block">Assinado em</small>
            <span v-if="signatureModal.signedAt">
              {{ signatureModal.signedAt | formatDateTime }}
            </span>
            <span v-else>-</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="5" class="mb-3 mb-lg-0">
            <b-card no-body>
              <b-card-header class="py-2">
                <strong>Assinatura</strong>
              </b-card-header>
              <b-card-body class="bg-white">
                <img
                  v-if="signatureSvgDataUrl"
                  :src="signatureSvgDataUrl"
                  alt="Assinatura"
                  class="signature-image"
                />
                <div v-else class="text-muted">Assinatura indisponível.</div>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col cols="12" lg="7">
            <b-card no-body>
              <b-card-header class="py-2">
                <strong>Termo assinado</strong>
              </b-card-header>
              <b-card-body class="signature-term">
                <pre class="mb-0">{{
                  signatureModal.term || 'Termo indisponível.'
                }}</pre>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      v-model="rescueDocumentModal.visible"
      title="Documento do resgate"
      size="lg"
      hide-footer
    >
      <b-row class="mb-3">
        <b-col cols="12" md="4" class="mb-2">
          <small class="text-muted d-block">Cliente</small>
          <strong>{{ rescueDocumentModal.customerName || '-' }}</strong>
        </b-col>
        <b-col cols="12" md="4" class="mb-2">
          <small class="text-muted d-block">Shopping</small>
          <strong>{{ rescueDocumentModal.storeName || '-' }}</strong>
        </b-col>
        <b-col cols="12" md="4" class="mb-2">
          <small class="text-muted d-block">Brinquedo</small>
          <strong>{{ rescueDocumentModal.toyName || '-' }}</strong>
        </b-col>
      </b-row>
      <img
        v-if="rescueDocumentModal.url"
        :src="rescueDocumentModal.url"
        alt="Documento do resgate"
        class="rescue-document-image"
      />
    </b-modal>
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import services from '@/services'
import { RENT_STATUS } from '@/constants'
import { formatCurrency } from '@/helpers/numbers'
import { formatDate, formatDateTime } from '@/helpers/date'
import { calculateExtraTime, calculatePausedTime } from '@/helpers/rents'
import { differenceInMinutes } from 'date-fns'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

const DEFAULT_VISIBLE_COLUMNS = [
  'store',
  'customer',
  'signature',
  'rescueDocument',
  'toy',
  'period',
  'createdAt',
  'status',
  'total'
]

const STORAGE_KEYS = {
  filters: 'driversys.adminRentsReport.filters',
  columns: 'driversys.adminRentsReport.columns',
  columnOrder: 'driversys.adminRentsReport.columnOrder',
  rankingMetric: 'driversys.adminRentsReport.rankingMetric',
  rankingEnabled: 'driversys.adminRentsReport.rankingEnabled'
}

const RANKING_METRIC_OPTIONS = [
  { value: 'loyaltyRescues', text: 'Resgates fidelidade', type: 'number' },
  { value: 'loyaltyDiscountAmount', text: 'Valor de desconto', type: 'money' },
  { value: 'loyaltyPointsConsumed', text: 'Pontos consumidos', type: 'number' },
  { value: 'totalRents', text: 'Total de alugueis', type: 'number' },
  { value: 'totalPaid', text: 'Total pago', type: 'money' },
  { value: 'canceledRents', text: 'Cancelamentos', type: 'number' }
]

const defaultFilters = () => {
  const today = formatDate(new Date())

  return {
    storeFilterMode: 'all',
    storeIds: [],
    status: [],
    customer: '',
    toyId: null,
    toyIds: [],
    periodId: null,
    periodIds: [],
    createdFrom: today,
    createdTo: today,
    endedFrom: null,
    endedTo: null
  }
}

const emptyFilters = () => ({
  storeFilterMode: 'all',
  storeIds: [],
  status: [],
  customer: '',
  toyId: null,
  toyIds: [],
  periodId: null,
  periodIds: [],
  createdFrom: null,
  createdTo: null,
  endedFrom: null,
  endedTo: null
})

const readStorage = (key, fallback) => {
  try {
    if (typeof window === 'undefined') return fallback

    const storedValue = window.localStorage.getItem(key)

    return storedValue ? JSON.parse(storedValue) : fallback
  } catch (error) {
    return fallback
  }
}

const writeStorage = (key, value) => {
  try {
    if (typeof window === 'undefined') return

    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    // Ignora indisponibilidade do localStorage.
  }
}

const DEFAULT_REPORT = {
  data: [],
  summary: {
    totalRents: 0,
    totalPayments: 0,
    active: 0,
    paused: 0,
    canceled: 0,
    closed: 0,
    rescued: 0
  },
  ranking: {
    customers: {
      loyaltyRescues: [],
      loyaltyDiscountAmount: [],
      loyaltyPointsConsumed: [],
      totalRents: [],
      totalPaid: [],
      canceledRents: []
    }
  },
  total: 0,
  page: 1,
  limit: 50,
  totalPages: 1
}

export default {
  name: 'AdminRentsReport',
  components: { Layout, VueSelect },
  filters: { formatCurrency, formatDateTime },
  data() {
    return {
      filters: {
        ...defaultFilters(),
        ...readStorage(STORAGE_KEYS.filters, {})
      },
      stores: [],
      toys: [],
      periods: [],
      report: { ...DEFAULT_REPORT },
      loading: false,
      error: null,
      signatureModal: {
        visible: false,
        loading: false,
        error: null,
        svg: null,
        signedAt: null,
        term: null,
        context: {
          customerName: null,
          customerDocument: null,
          storeName: null,
          toyName: null,
          periodLabel: null
        }
      },
      rescueDocumentModal: {
        visible: false,
        url: null,
        customerName: null,
        storeName: null,
        toyName: null
      },
      visibleColumnKeys: readStorage(STORAGE_KEYS.columns, [
        ...DEFAULT_VISIBLE_COLUMNS
      ]),
      rankingMetric: readStorage(
        STORAGE_KEYS.rankingMetric,
        RANKING_METRIC_OPTIONS[0].value
      ),
      rankingEnabled: readStorage(STORAGE_KEYS.rankingEnabled, false),
      columnOrderKeys: readStorage(STORAGE_KEYS.columnOrder, [])
    }
  },
  computed: {
    breadcrumbs() {
      return [
        { text: 'Início', to: { name: 'HomeIndex' } },
        { text: 'Relatórios', to: { name: 'ReportsIndex' } },
        { text: 'Relatório Admin de Aluguéis', active: true }
      ]
    },
    rows() {
      return Array.isArray(this.report.data) ? this.report.data : []
    },
    allFields() {
      return [
        { key: 'id', label: 'ID' },
        { key: 'store', label: 'Shopping' },
        { key: 'customer', label: 'Cliente' },
        { key: 'customerDetails', label: 'Dados do cliente' },
        { key: 'signature', label: 'Assinatura' },
        { key: 'rescueDocument', label: 'Doc. resgate' },
        { key: 'toy', label: 'Brinquedo' },
        { key: 'period', label: 'Período' },
        { key: 'createdAt', label: 'Criado em' },
        { key: 'endedAt', label: 'Finalizado em' },
        { key: 'extraTime', label: 'Adicional' },
        { key: 'pausedTime', label: 'Pausado' },
        { key: 'exceededTime', label: 'Excedido' },
        { key: 'rentTime', label: 'Permanência' },
        { key: 'chargedTime', label: 'Cobrado' },
        { key: 'extraTimeReason', label: 'Motivo tempo adicional' },
        { key: 'cancelReason', label: 'Motivo cancelamento' },
        { key: 'status', label: 'Status' },
        { key: 'cash', label: 'Dinheiro' },
        { key: 'creditCard', label: 'Crédito' },
        { key: 'debitCard', label: 'Débito' },
        { key: 'pix', label: 'Pix' },
        { key: 'discount', label: 'Desconto' },
        { key: 'grossTotal', label: 'Total bruto' },
        { key: 'total', label: 'Total pago' }
      ]
    },
    visibleFields() {
      return this.orderedVisibleFields.length
        ? this.orderedVisibleFields
        : [this.allFields[0]]
    },
    orderedVisibleFields() {
      const fieldByKey = this.allFields.reduce((result, field) => {
        result[field.key] = field
        return result
      }, {})

      return this.columnOrderKeys
        .filter((key) => this.visibleColumnKeys.includes(key))
        .map((key) => fieldByKey[key])
        .filter(Boolean)
    },
    columnGroups() {
      const fieldByKey = this.allFields.reduce((result, field) => {
        result[field.key] = field
        return result
      }, {})

      return [
        {
          label: 'Identificação',
          keys: [
            'id',
            'store',
            'toy',
            'period',
            'createdAt',
            'endedAt',
            'status'
          ]
        },
        {
          label: 'Cliente e assinatura',
          keys: ['customer', 'customerDetails', 'signature']
        },
        {
          label: 'Tempos e motivos',
          keys: [
            'extraTime',
            'pausedTime',
            'exceededTime',
            'rentTime',
            'chargedTime',
            'extraTimeReason',
            'cancelReason'
          ]
        },
        {
          label: 'Pagamentos e descontos',
          keys: [
            'cash',
            'creditCard',
            'debitCard',
            'pix',
            'discount',
            'grossTotal',
            'total'
          ]
        }
      ].map((group) => ({
        ...group,
        options: group.keys
          .map((key) => fieldByKey[key])
          .filter(Boolean)
          .map((field) => ({
            value: field.key,
            text: field.label
          }))
      }))
    },
    storeFilterOptions() {
      return this.stores.filter(
        (store) => !this.selectedStoreIds.includes(Number(store.id))
      )
    },
    storeFilterSelection: {
      get() {
        if (this.filters.storeFilterMode === 'all') return []

        return this.stores.filter((store) =>
          this.selectedStoreIds.includes(Number(store.id))
        )
      },
      set(selection) {
        this.applyStoreFilterSelection(selection)
      }
    },
    selectedStoreIds() {
      return Array.isArray(this.filters.storeIds)
        ? this.filters.storeIds
            .map((storeId) => Number(storeId))
            .filter((storeId) => Number.isFinite(storeId) && storeId > 0)
        : []
    },
    effectiveStoreIds() {
      const allStoreIds = this.stores.map((store) => Number(store.id))

      if (this.filters.storeFilterMode === 'include') {
        return this.selectedStoreIds
      }

      return allStoreIds
    },
    selectedSingleStoreId() {
      return this.selectedStoreIds.length === 1
        ? this.selectedStoreIds[0]
        : null
    },
    storeDependentFiltersDisabled() {
      return !this.selectedSingleStoreId
    },
    storeDependentEmptyOptionText() {
      return this.selectedStoreIds.length > 1
        ? 'Selecione apenas um shopping'
        : 'Selecione um shopping primeiro'
    },
    selectedToyIds() {
      return Array.isArray(this.filters.toyIds)
        ? this.filters.toyIds
            .map((toyId) => Number(toyId))
            .filter((toyId) => Number.isFinite(toyId) && toyId > 0)
        : []
    },
    toysForSelectedStore() {
      if (!this.selectedSingleStoreId) return []

      return this.toys.filter(
        (toy) => Number(toy.storeId) === this.selectedSingleStoreId
      )
    },
    toyFilterOptions() {
      return this.toysForSelectedStore
        .filter((toy) => !this.selectedToyIds.includes(Number(toy.id)))
        .map((toy) => ({
          id: toy.id,
          text: this.toyOptionLabel(toy)
        }))
    },
    toyFilterSelection: {
      get() {
        return this.toysForSelectedStore
          .filter((toy) => this.selectedToyIds.includes(Number(toy.id)))
          .map((toy) => ({
            id: toy.id,
            text: this.toyOptionLabel(toy)
          }))
      },
      set(selection) {
        this.applyToyFilterSelection(selection)
      }
    },
    toyFilterPlaceholder() {
      return this.selectedSingleStoreId
        ? 'Todos os carrinhos'
        : this.storeDependentEmptyOptionText
    },
    periodOptions() {
      if (!this.selectedSingleStoreId) {
        return [{ value: null, text: this.storeDependentEmptyOptionText }]
      }

      const periods = this.periods.filter(
        (period) => Number(period.storeId) === this.selectedSingleStoreId
      )

      return [
        { value: null, text: 'Todos os períodos' },
        ...periods.map((period) => ({
          value: period.id,
          text: period.store?.name
            ? `${period.store.name} - ${period.time} min`
            : `${period.time} min`
        }))
      ]
    },
    statusOptions() {
      return [
        { value: null, text: 'Todos os status' },
        { value: 'active', text: 'Ativo' },
        { value: 'paused', text: 'Pausado' },
        { value: 'canceled', text: 'Cancelado' },
        { value: 'closed', text: 'Finalizado' },
        { value: 'rescued', text: 'Resgatado' }
      ]
    },
    statusChoices() {
      return this.statusOptions.filter((option) => option.value)
    },
    selectedStatuses() {
      return Array.isArray(this.filters.status)
        ? this.filters.status.filter((status) =>
            this.statusChoices.some((option) => option.value === status)
          )
        : []
    },
    statusFilterOptions() {
      return this.statusChoices.filter(
        (option) => !this.selectedStatuses.includes(option.value)
      )
    },
    statusFilterSelection: {
      get() {
        return this.statusChoices.filter((option) =>
          this.selectedStatuses.includes(option.value)
        )
      },
      set(selection) {
        this.applyStatusFilterSelection(selection)
      }
    },
    selectedPeriodIds() {
      return Array.isArray(this.filters.periodIds)
        ? this.filters.periodIds
            .map((periodId) => Number(periodId))
            .filter((periodId) => Number.isFinite(periodId) && periodId > 0)
        : []
    },
    periodsForSelectedStore() {
      if (!this.selectedSingleStoreId) return []

      return this.periods.filter(
        (period) => Number(period.storeId) === this.selectedSingleStoreId
      )
    },
    periodFilterOptions() {
      return this.periodsForSelectedStore
        .filter((period) => !this.selectedPeriodIds.includes(Number(period.id)))
        .map((period) => ({
          id: period.id,
          text: this.periodOptionLabel(period)
        }))
    },
    periodFilterSelection: {
      get() {
        return this.periodsForSelectedStore
          .filter((period) =>
            this.selectedPeriodIds.includes(Number(period.id))
          )
          .map((period) => ({
            id: period.id,
            text: this.periodOptionLabel(period)
          }))
      },
      set(selection) {
        this.applyPeriodFilterSelection(selection)
      }
    },
    periodFilterPlaceholder() {
      return this.selectedSingleStoreId
        ? 'Todos os Periodos'
        : this.storeDependentEmptyOptionText
    },
    rankingMetricOptions() {
      return RANKING_METRIC_OPTIONS.map(({ value, text }) => ({ value, text }))
    },
    rankingMetricConfig() {
      return (
        RANKING_METRIC_OPTIONS.find(
          (option) => option.value === this.rankingMetric
        ) || RANKING_METRIC_OPTIONS[0]
      )
    },
    customerRankingRows() {
      const customers = this.report.ranking?.customers || {}
      const rows = customers[this.rankingMetricConfig.value]

      return Array.isArray(rows) ? rows : []
    },
    customerRankingFields() {
      return [
        { key: 'position', label: '#' },
        { key: 'customer', label: 'Cliente' },
        { key: 'metricValue', label: this.rankingMetricConfig.text },
        { key: 'loyaltyRescues', label: 'Resgates' },
        { key: 'loyaltyDiscountAmount', label: 'Desconto' },
        { key: 'loyaltyPointsConsumed', label: 'Pontos' },
        { key: 'totalRents', label: 'Alugueis' },
        { key: 'totalPaid', label: 'Pago' },
        { key: 'canceledRents', label: 'Cancel.' }
      ]
    },
    summaryItems() {
      const summary = this.report.summary || DEFAULT_REPORT.summary

      return [
        { label: 'Aluguéis', value: summary.totalRents },
        { label: 'Total pago', value: formatCurrency(summary.totalPayments) },
        { label: 'Ativos', value: summary.active },
        { label: 'Pausados', value: summary.paused },
        { label: 'Finalizados', value: summary.closed },
        { label: 'Cancelados', value: summary.canceled }
      ]
    },
    signatureSvgDataUrl() {
      const svg = this.signatureModal.svg || ''

      return svg
        ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
        : ''
    }
  },
  watch: {
    filters: {
      deep: true,
      handler(filters) {
        writeStorage(STORAGE_KEYS.filters, filters)
      }
    },
    'filters.storeFilterMode'() {
      this.normalizeStoreFilters()
      this.ensureStoreDependentFilters()
    },
    'filters.storeIds'() {
      this.ensureStoreDependentFilters()
    },
    visibleColumnKeys(columnKeys) {
      writeStorage(STORAGE_KEYS.columns, this.normalizeColumnKeys(columnKeys))
    },
    rankingMetric(metric) {
      const validMetric = RANKING_METRIC_OPTIONS.some(
        (option) => option.value === metric
      )

      if (validMetric) {
        writeStorage(STORAGE_KEYS.rankingMetric, metric)
      }
    },
    rankingEnabled(enabled) {
      writeStorage(STORAGE_KEYS.rankingEnabled, Boolean(enabled))
    },
    columnOrderKeys(columnKeys) {
      writeStorage(
        STORAGE_KEYS.columnOrder,
        this.normalizeColumnOrderKeys(columnKeys)
      )
    }
  },
  created() {
    this.normalizeStoreFilters()
    this.normalizeMultiFilters()
    this.visibleColumnKeys = this.normalizeColumnKeys(this.visibleColumnKeys)
    this.columnOrderKeys = this.normalizeColumnOrderKeys(this.columnOrderKeys)
    this.rankingMetric = this.normalizeRankingMetric(this.rankingMetric)
    this.loadOptions()
    this.loadReport()
  },
  methods: {
    async loadOptions() {
      try {
        const [stores, periods, toys] = await Promise.all([
          services.stores.fetchStores(),
          services.periods.fetchAllPeriods(),
          services.toys.fetchAllToys()
        ])

        this.stores = Array.isArray(stores) ? stores : []
        this.periods = Array.isArray(periods) ? periods : []
        this.toys = Array.isArray(toys) ? toys : []
        this.ensureStoreDependentFilters()
      } catch (error) {
        this.stores = []
        this.periods = []
        this.toys = []
      }
    },
    async loadReport(page = 1) {
      this.loading = true
      this.error = null
      this.normalizeMultiFilters()

      try {
        this.report = await services.reports.fetchAdminRentsReport({
          ...this.filters,
          includeRanking: this.rankingEnabled,
          page,
          limit: this.report.limit || 50
        })
      } catch (error) {
        this.error =
          error?.response?.data?.message ||
          error?.message ||
          'Não foi possível carregar o relatório.'
        this.report = { ...DEFAULT_REPORT }
      } finally {
        this.loading = false
      }
    },
    clearFilters() {
      this.filters = emptyFilters()
      this.loadReport(1)
    },
    handleRankingToggle(enabled) {
      this.rankingEnabled = Boolean(enabled)
      this.$nextTick(() => this.loadReport(1))
    },
    selectAllStores() {
      this.filters.storeFilterMode = 'include'
      this.filters.storeIds = this.stores.map((store) => Number(store.id))
    },
    clearStoreSelection() {
      this.filters.storeFilterMode = 'all'
      this.filters.storeIds = []
    },
    applyStoreFilterSelection(selection) {
      const stores = Array.isArray(selection) ? selection : []
      const storeIds = stores
        .map((store) => Number(store.id))
        .filter((storeId, index, storeIds) => {
          return (
            Number.isFinite(storeId) &&
            storeId > 0 &&
            storeIds.indexOf(storeId) === index
          )
        })

      if (!storeIds.length) {
        this.filters.storeFilterMode = 'all'
        this.filters.storeIds = []
        return
      }

      this.filters.storeFilterMode = 'include'
      this.filters.storeIds = storeIds
    },
    selectAllStatuses() {
      this.filters.status = this.statusChoices.map((option) => option.value)
    },
    clearStatusSelection() {
      this.filters.status = []
    },
    applyStatusFilterSelection(selection) {
      this.filters.status = (Array.isArray(selection) ? selection : [])
        .map((option) => option.value)
        .filter((status, index, statuses) => {
          return (
            this.statusChoices.some((option) => option.value === status) &&
            statuses.indexOf(status) === index
          )
        })
    },
    selectAllToys() {
      this.filters.toyIds = this.toysForSelectedStore.map((toy) =>
        Number(toy.id)
      )
    },
    clearToySelection() {
      this.filters.toyIds = []
    },
    applyToyFilterSelection(selection) {
      this.filters.toyIds = (Array.isArray(selection) ? selection : [])
        .map((toy) => Number(toy.id))
        .filter((toyId, index, toyIds) => {
          return (
            Number.isFinite(toyId) &&
            toyId > 0 &&
            toyIds.indexOf(toyId) === index
          )
        })
    },
    selectAllPeriods() {
      this.filters.periodIds = this.periodsForSelectedStore.map((period) =>
        Number(period.id)
      )
    },
    clearPeriodSelection() {
      this.filters.periodIds = []
    },
    applyPeriodFilterSelection(selection) {
      this.filters.periodIds = (Array.isArray(selection) ? selection : [])
        .map((period) => Number(period.id))
        .filter((periodId, index, periodIds) => {
          return (
            Number.isFinite(periodId) &&
            periodId > 0 &&
            periodIds.indexOf(periodId) === index
          )
        })
    },
    normalizeStoreFilters() {
      const validModes = ['all', 'include']
      const legacyStoreId = Number(this.filters.storeId)
      const hasLegacyStoreId =
        Number.isFinite(legacyStoreId) && legacyStoreId > 0

      if (!validModes.includes(this.filters.storeFilterMode)) {
        this.filters.storeFilterMode = hasLegacyStoreId ? 'include' : 'all'
      }

      if (!Array.isArray(this.filters.storeIds)) {
        this.filters.storeIds = hasLegacyStoreId ? [legacyStoreId] : []
      }

      this.filters.storeIds = this.filters.storeIds
        .map((storeId) => Number(storeId))
        .filter((storeId, index, storeIds) => {
          return (
            Number.isFinite(storeId) &&
            storeId > 0 &&
            storeIds.indexOf(storeId) === index
          )
        })

      if (this.filters.storeFilterMode === 'all') {
        this.filters.storeIds = []
      }

      if (Object.prototype.hasOwnProperty.call(this.filters, 'storeId')) {
        this.$delete(this.filters, 'storeId')
      }
    },
    normalizeMultiFilters() {
      if (!Array.isArray(this.filters.status)) {
        this.filters.status = this.filters.status ? [this.filters.status] : []
      }

      this.filters.status = this.filters.status.filter((status, index) => {
        return (
          this.statusChoices.some((option) => option.value === status) &&
          this.filters.status.indexOf(status) === index
        )
      })

      this.normalizeIdListFilter('toyIds', 'toyId')
      this.normalizeIdListFilter('periodIds', 'periodId')
    },
    normalizeIdListFilter(listKey, legacyKey) {
      const legacyValue = Number(this.filters[legacyKey])

      if (!Array.isArray(this.filters[listKey])) {
        this.filters[listKey] =
          Number.isFinite(legacyValue) && legacyValue > 0 ? [legacyValue] : []
      }

      this.filters[listKey] = this.filters[listKey]
        .map((value) => Number(value))
        .filter((value, index, values) => {
          return (
            Number.isFinite(value) &&
            value > 0 &&
            values.indexOf(value) === index
          )
        })

      if (Object.prototype.hasOwnProperty.call(this.filters, legacyKey)) {
        this.$delete(this.filters, legacyKey)
      }
    },
    ensureStoreDependentFilters() {
      if (!this.selectedSingleStoreId) {
        this.filters.toyIds = []
        this.filters.periodIds = []
        return
      }

      this.filters.toyIds = this.selectedToyIds.filter((toyId) =>
        this.toysForSelectedStore.some((toy) => Number(toy.id) === toyId)
      )
      this.filters.periodIds = this.selectedPeriodIds.filter((periodId) =>
        this.periodsForSelectedStore.some(
          (period) => Number(period.id) === periodId
        )
      )
    },
    toyOptionLabel(toy) {
      const store = this.stores.find(
        (store) => Number(store.id) === Number(toy.storeId)
      )

      return store?.name ? `${store.name} - ${toy.name}` : toy.name
    },
    periodOptionLabel(period) {
      return period.store?.name
        ? `${period.store.name} - ${period.time} min`
        : `${period.time} min`
    },
    normalizeColumnKeys(columnKeys) {
      if (!Array.isArray(columnKeys)) return [...DEFAULT_VISIBLE_COLUMNS]

      const validKeys = this.allFields.map((field) => field.key)

      return columnKeys.filter((key) => validKeys.includes(key))
    },
    normalizeColumnOrderKeys(columnKeys) {
      const validKeys = this.allFields.map((field) => field.key)
      const normalizedKeys = Array.isArray(columnKeys)
        ? columnKeys.filter((key, index) => {
            return validKeys.includes(key) && columnKeys.indexOf(key) === index
          })
        : []

      return [
        ...normalizedKeys,
        ...validKeys.filter((key) => !normalizedKeys.includes(key))
      ]
    },
    normalizeRankingMetric(metric) {
      return RANKING_METRIC_OPTIONS.some((option) => option.value === metric)
        ? metric
        : RANKING_METRIC_OPTIONS[0].value
    },
    formatRankingValue(item, metric) {
      const config =
        RANKING_METRIC_OPTIONS.find((option) => option.value === metric) ||
        RANKING_METRIC_OPTIONS[0]
      const value = Number(item?.[config.value] || 0)

      return config.type === 'money' ? formatCurrency(value) : value
    },
    moveColumn(key, direction) {
      const visibleOrder = this.orderedVisibleFields.map((field) => field.key)
      const fromIndex = visibleOrder.indexOf(key)
      const toIndex = fromIndex + direction

      if (fromIndex < 0 || toIndex < 0 || toIndex >= visibleOrder.length) {
        return
      }

      const targetKey = visibleOrder[toIndex]
      const nextOrder = [...this.columnOrderKeys]
      const sourceOrderIndex = nextOrder.indexOf(key)
      const targetOrderIndex = nextOrder.indexOf(targetKey)

      if (sourceOrderIndex < 0 || targetOrderIndex < 0) return

      nextOrder.splice(sourceOrderIndex, 1)
      nextOrder.splice(targetOrderIndex, 0, key)
      this.columnOrderKeys = this.normalizeColumnOrderKeys(nextOrder)
    },
    openRescueDocumentModal(rent) {
      this.rescueDocumentModal = {
        visible: true,
        url: rent?.rescueDocumentPhotoUrl || null,
        customerName: rent?.customer?.name || null,
        storeName: rent?.store?.name || null,
        toyName: rent?.toy?.name || null
      }
    },
    async openSignatureModal(rent) {
      this.signatureModal.visible = true
      this.signatureModal.loading = true
      this.signatureModal.error = null
      this.signatureModal.svg = null
      this.signatureModal.signedAt = null
      this.signatureModal.term = null
      this.signatureModal.context = {
        customerName: rent.customer?.name || null,
        customerDocument: rent.customer?.document || null,
        storeName: rent.store?.name || null,
        toyName: rent.toy?.name || null,
        periodLabel: rent.period?.time ? `${rent.period.time} min` : null
      }

      try {
        const signature = await services.rents.fetchRentSignature(rent.id)
        this.signatureModal.svg = signature.signatureSvg
        this.signatureModal.signedAt = signature.signedAt
        this.signatureModal.term = signature.termAccept
      } catch (error) {
        this.signatureModal.error =
          error?.response?.data?.message ||
          error?.message ||
          'Não foi possível carregar a assinatura.'
      } finally {
        this.signatureModal.loading = false
      }
    },
    rentPaymentTotal(rent) {
      return Array.isArray(rent.payments)
        ? rent.payments.reduce(
            (total, payment) => total + (payment.amount || 0),
            0
          )
        : 0
    },
    grossPaymentTotal(rent) {
      return this.rentPaymentTotal(rent) + this.discountAmount(rent)
    },
    discountAmount(rent) {
      return Number(rent.loyaltyDiscount?.discountAmount || 0)
    },
    paymentByType(rent, type) {
      return Array.isArray(rent.payments)
        ? rent.payments
            .filter((payment) => payment.type === type)
            .reduce((total, payment) => total + (payment.amount || 0), 0)
        : 0
    },
    customerDocument(rent) {
      return rent.customer?.document || 'Sem CPF'
    },
    customerPhone(rent) {
      return rent.customer?.phone || 'Sem telefone'
    },
    customerEmail(rent) {
      return rent.customer?.email || 'Sem e-mail'
    },
    getExtraTime(rent) {
      return calculateExtraTime({
        ...rent,
        extraTime: this.extraTimes(rent)
      })
    },
    getPausedTime(rent) {
      const basePaused = calculatePausedTime({
        ...rent,
        extraTime: this.extraTimes(rent)
      })

      if (!rent.pausedAt) return basePaused

      const pausedAt = new Date(rent.pausedAt)
      const resumedAt = rent.resumedAt ? new Date(rent.resumedAt) : null
      const pauseStillOpenSincePausedAt = !resumedAt || resumedAt <= pausedAt

      if (rent.status === RENT_STATUS.PAUSED.value && !rent.endedAt) {
        return (
          basePaused + Math.max(0, differenceInMinutes(new Date(), pausedAt))
        )
      }

      if (rent.endedAt && pauseStillOpenSincePausedAt) {
        const endedAt = new Date(rent.endedAt)
        return basePaused + Math.max(0, differenceInMinutes(endedAt, pausedAt))
      }

      if (rent.canceledAt && pauseStillOpenSincePausedAt) {
        const canceledAt = new Date(rent.canceledAt)
        return (
          basePaused + Math.max(0, differenceInMinutes(canceledAt, pausedAt))
        )
      }

      return basePaused
    },
    getRentTime(rent) {
      const endDate = rent.canceledAt
        ? new Date(rent.canceledAt)
        : rent.endedAt
        ? new Date(rent.endedAt)
        : new Date()

      return Math.max(0, differenceInMinutes(endDate, new Date(rent.createdAt)))
    },
    getExceededTime(rent) {
      if (!rent.period) return 0

      const netTime =
        this.getRentTime(rent) -
        this.getPausedTime(rent) -
        this.getExtraTime(rent)

      return Math.max(0, netTime - rent.period.time)
    },
    getChargedTime(rent) {
      return Math.max(
        0,
        this.getRentTime(rent) -
          this.getPausedTime(rent) -
          this.getExtraTime(rent)
      )
    },
    getExtraTimeReason(rent) {
      const reasons = this.extraTimes(rent)
        .filter((extraTime) => extraTime.type !== 'pause')
        .map((extraTime) => extraTime.reason)
        .filter(Boolean)

      return reasons.length ? reasons.join(' / ') : '-'
    },
    getCancelReason(rent) {
      return rent.cancelRent?.reason || '-'
    },
    extraTimes(rent) {
      return Array.isArray(rent.extraTime) ? rent.extraTime : []
    },
    resetColumns() {
      this.visibleColumnKeys = [...DEFAULT_VISIBLE_COLUMNS]
      this.columnOrderKeys = this.normalizeColumnOrderKeys([])
    },
    selectAllColumns() {
      this.visibleColumnKeys = this.allFields.map((field) => field.key)
    },
    statusText(status) {
      const statusMap = {
        [RENT_STATUS.ACTIVE.value]: 'Ativo',
        [RENT_STATUS.PAUSED.value]: 'Pausado',
        [RENT_STATUS.CANCELLED.value]: 'Cancelado',
        closed: 'Finalizado',
        rescued: 'Resgatado'
      }

      return statusMap[status] || status
    },
    statusVariant(status) {
      return (
        {
          active: 'success',
          paused: 'warning',
          canceled: 'danger',
          closed: 'secondary',
          rescued: 'info'
        }[status] || 'light'
      )
    }
  }
}
</script>

<style scoped>
.admin-report-filters {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
}

.admin-report-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.admin-store-select,
.admin-filter-select {
  background: #fff;
}

.admin-store-select .vs__dropdown-toggle,
.admin-filter-select .vs__dropdown-toggle {
  min-height: 38px;
}

.admin-store-select-actions,
.admin-filter-select-actions {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
}

.admin-store-select-actions .btn,
.admin-filter-select-actions .btn {
  flex: 1 1 0;
}

.summary-tile {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  min-height: 64px;
  padding: 0.75rem;
}

.customer-ranking {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

.ranking-metric-select {
  max-width: 260px;
}

.table-frame {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  overflow: hidden;
}

.pagination-container {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.page-info {
  flex-grow: 1;
  font-weight: bold;
  text-align: center;
}

.column-menu {
  min-width: 300px;
  max-height: 70vh;
  overflow-y: auto;
}

.column-toolbar {
  gap: 0.5rem;
}

.column-order-menu {
  min-width: 280px;
  max-height: 70vh;
  overflow-y: auto;
}

.column-order-list {
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
}

.column-order-item {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  min-height: 34px;
}

.column-order-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.column-order-actions {
  display: flex;
  gap: 0.25rem;
}

.column-order-actions .btn {
  align-items: center;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 32px;
}

.column-group {
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
}

.column-group:last-of-type {
  border-bottom: 0;
  margin-bottom: 0;
}

.column-group-title {
  color: #6c757d;
  display: block;
  font-weight: 700;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
}

.signature-image {
  max-height: 320px;
  max-width: 100%;
}

.rescue-document-image {
  display: block;
  max-height: 70vh;
  object-fit: contain;
  width: 100%;
}

.signature-term {
  max-height: 360px;
  overflow: auto;
}

.signature-term pre {
  font-family: inherit;
  white-space: pre-wrap;
}

.customer-info-line {
  align-items: center;
  display: flex;
  gap: 0.25rem;
  white-space: nowrap;
}

.customer-info-icon {
  flex: 0 0 auto;
}
</style>
